import { CheckCircleIcon } from "@heroicons/react/24/outline";
import getConfig from "next/config";
import Image from "next/image";

const { publicRuntimeConfig } = getConfig();
const { NEXT_PUBLIC_CDN_URL } = publicRuntimeConfig;

interface Panel1Props {
  partner?: string;
}

export default function Panel1(props: Panel1Props) {
  return (
    <div id="panel-1" className="w-full">
      <div className="relative flex bg-no-repeat bg-cover bg-panel-background">
        <Image
          className="absolute object-cover opacity-20 hover:cursor-pointer"
          src={`${NEXT_PUBLIC_CDN_URL}/landing_page/svg/bg-waves-orange-1.svg`}
          alt="waves-header"
          layout="fill"
        />
        <div className="flex flex-row container 3xl:max-w-[1750px!important] md:items-center relative justify-center md:justify-start w-full min-h-[80vh] md:text-left max-h-[1500px]">
          <div
            className="flex flex-col items-center justify-center w-full gap-8 py-8 md:justify-between md:h-full md:flex-row"
            style={{ zIndex: "1" }}
          >
            <div className="flex flex-col md:w-[48%]">
              <div className="text-white">
                <div className="my-2 lg:!leading-snug text-2xl text-center md:text-left md:text-3xl lg:text-4xl 3xl:text-6xl">
                  <h1 className="inline-block font-bold text-transparent bg-gradient-to-r from-orange-200 via-brown-200 to-yellow-100 bg-clip-text">
                    Grow your business as a RoadFlex Partner
                  </h1>
                </div>
                <div className="mb-1 font-normal text-center md:text-left lg:text-lg 3xl:text-2xl">
                  <div>
                    Help your customers increase profitability with a premium
                    business card built specifically for fleets. Partnering with
                    RoadFlex is simple.
                  </div>
                </div>
              </div>

              <div className="hidden text-lg font-medium text-center md:pt-2 md:text-left md:block">
                <div className="flex flex-col text-white">
                  <div className="md:mt-4">
                    <div className="flex flex-row">
                      <div className="flex items-center justify-center">
                        <CheckCircleIcon className="w-4 h-4 mr-1 text-white stroke-[2px] sm:w-7 sm:h-7" />
                      </div>
                      <div className="pl-1">
                        Visa Business Card, accepted everywhere
                      </div>
                    </div>
                  </div>
                  <div className="md:mt-4">
                    <div className="flex flex-row">
                      <div className="flex items-center justify-center">
                        <CheckCircleIcon className="w-4 h-4 mr-1 text-white stroke-[2px] sm:w-7 sm:h-7" />
                      </div>
                      <div className="pl-1">
                        Competitive Discounts & Rebates
                      </div>
                    </div>
                  </div>
                  <div className="md:mt-4">
                    <div className="flex flex-row">
                      <div className="flex items-center justify-center">
                        <CheckCircleIcon className="w-4 h-4 mr-1 text-white stroke-[2px] sm:w-7 sm:h-7" />
                      </div>
                      <div className="pl-1">
                        Dedicated customer success and 7-day support
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="w-[80%] h-auto max-h-[750px] xs:max-w-[400px] md:max-w-[500px] 3xl:max-w-[600px]">
              <Image
                layout="responsive"
                width={20}
                height={17}
                loading="eager"
                className=""
                src={`${NEXT_PUBLIC_CDN_URL}/partnership/images/partnerships-banner.png`}
                alt="RoadFlex Partnerships"
              ></Image>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
